export interface MfRemoteRegistryEntry {
  /** Module-federation remote name — the key used in environment `remotes`. */
  federationName: string;
  /** Nx project that builds this remote (used by the e2e pipeline pre-step). */
  nxProject: string;
  /** Port used when serving the remote locally for development. */
  devPort: number;
}

/**
 * Single source of truth for module-federation remotes. Register a new MF
 * module here and the local resolution, the derived localhost map, and the e2e
 * pipeline pre-step (build + upload + override) all pick it up automatically —
 * no per-module wiring elsewhere.
 */
export const MF_REMOTES: readonly MfRemoteRegistryEntry[] = [
  { federationName: 'mfe-header', nxProject: 'mfe-header', devPort: 5201 },
  {
    federationName: 'mfeJobPlanner',
    nxProject: 'mfeJobPlanner',
    devPort: 5203,
  },
];

/** Derived map of remote name -> localhost authority, for local dev serving. */
export const REMOTE_LOCALHOSTS: Record<string, string> = Object.fromEntries(
  MF_REMOTES.map((remote) => [
    remote.federationName,
    `localhost:${remote.devPort}`,
  ]),
);
